<div class="contenedor-form">
  <form [formGroup]="consultaGroup" class="example-form">
    <div class="row">
      <div class="col s12 m4 l4">
        <span *ngIf="productosGrupoLoading">
          <mat-spinner
            [diameter]="30"
            style="margin: 0 auto; top: 15px"
          ></mat-spinner>
        </span>
        <span *ngIf="!productosGrupoLoading">
          <mat-form-field class="example-full-width">
            <input
              matInput
              id="grupo"
              placeholder="GRUPO"
              #inputGrupo
              #triggerGrupo="matAutocompleteTrigger"
              [matAutocomplete]="autoGrupo"
              formControlName="grupo"
            />
            <button
              mat-button
              *ngIf="consultaGroup.get('grupo').value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="
                limpiarInput('grupo', triggerGrupo); $event.stopPropagation()
              "
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete
              #autoGrupo="matAutocomplete"
              [displayWith]="displayGrupoFn"
            >
              <mat-option
                *ngFor="let item of filteredGrupos | async"
                [value]="item"
              >
                <span>{{ item.valor }}</span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </span>
      </div>
      <div class="col s12 m4 l4">
        <span *ngIf="productosLineaLoading">
          <mat-spinner
            [diameter]="30"
            style="margin: 0 auto; top: 15px"
          ></mat-spinner>
        </span>
        <span *ngIf="!productosLineaLoading">
          <mat-form-field class="example-full-width">
            <input
              matInput
              #triggerLinea="matAutocompleteTrigger"
              placeholder="LINEA"
              [matAutocomplete]="autoLinea"
              formControlName="linea"
            />
            <button
              mat-button
              *ngIf="consultaGroup.get('linea').value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="
                limpiarInput('linea', triggerLinea); $event.stopPropagation()
              "
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete
              #autoLinea="matAutocomplete"
              [displayWith]="displayLineaFn"
            >
              <mat-option
                *ngFor="let item of filteredLineas | async"
                [value]="item"
              >
                <span>{{ item.valor }}</span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </span>
      </div>
      <div class="col s12 m4 l4">
        <span *ngIf="productosMarcaLoading">
          <mat-spinner
            [diameter]="30"
            style="margin: 0 auto; top: 15px"
          ></mat-spinner>
        </span>
        <span *ngIf="!productosMarcaLoading">
          <mat-form-field class="example-full-width">
            <input
              matInput
              placeholder="MARCA"
              #triggerMarca="matAutocompleteTrigger"
              [matAutocomplete]="autoMarca"
              formControlName="marca"
            />
            <button
              mat-button
              *ngIf="consultaGroup.get('marca').value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="
                limpiarInput('marca', triggerMarca); $event.stopPropagation()
              "
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete
              #autoMarca="matAutocomplete"
              [displayWith]="displayMarcaFn"
            >
              <mat-option
                *ngFor="let item of filteredMarcas | async"
                [value]="item"
              >
                <span>{{ item.valor }}</span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col s12 m10 l10">
        <mat-form-field class="example-full-width">
          <mat-label>PRODUCTO</mat-label>
          <input
            matInput
            placeholder="PRODUCTO"
            formControlName="producto"
            (keydown.enter)="busqueda(); $event.stopPropagation()"
          />
          <button
            mat-button
            *ngIf="consultaGroup.get('producto').value"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="
              limpiarInput('producto', triggerMarca); $event.stopPropagation()
            "
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint>codigo de producto o descripción</mat-hint>
        </mat-form-field>
      </div>
      <div class="col s12 m2 l2" style="text-align: center">
        <button
          type="button"
          (click)="busqueda()"
          [disabled]="!consultaGroup.valid"
          mat-raised-button
          color="accent"
        >
          BUSCAR
        </button>
      </div>
    </div>
  </form>
</div>
